import React, { useState } from "react";
import StatesContext from "./StatesContext";

const OverAllStates = (props) => {

    let activeMode = false
    let x = (localStorage.getItem('darkMode'))
    if (x === 'true') {
        activeMode = true
    }

    const [darkToggle, setDarkToggle] = useState(activeMode)
    const [messages, setMessages] = useState([]);

    return (
        <StatesContext.Provider
            value={{
                darkToggle, setDarkToggle,
                messages, setMessages   
                         }}>
            {props.children}
        </StatesContext.Provider>
    )
}
export default OverAllStates;